import dayjs from 'dayjs';

/**
 * Reads a string value out of a search result's `data` bag. The payload types values as
 * `unknown` and omits empty keys entirely, so we treat anything non-string or empty as absent.
 */
export function dataString(data: Record<string, unknown>, key: string): string | undefined {
  const value = data[key];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

/**
 * The labelled date line for a delivery/order result: delivered date, else booked date
 */
export function resultDateLine(data: Record<string, unknown>): string | undefined {
  const delivered = dataString(data, 'deliveredTime');
  if (delivered) {
    return `Delivered: ${dayjs(delivered).format('DD MMM YYYY')}`;
  }
  const booked = dataString(data, 'bookedTime');
  return booked ? `Booked: ${dayjs(booked).format('DD MMM YYYY')}` : undefined;
}
